'use client';

import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["date"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import 'styles/hacks/react-date-picker-hack.css';
import { dateIsBefore, datesAreEqual } from '@lib/util/date-ops';
import { useLanguageConfig } from '@lib/context/shared/lang-context';
import { es } from "date-fns/locale";
import { MODIFIER_CALENDAR_CLASS_NAMES } from '@lib/constants';
import CalendarDayContent from '../../calendar-day-content';
import { getModifiers } from '@lib/util/range-picker-ops';
import CalendarCaption from '../../calendar-caption';
import APP_CONFIGURATION from '@lib/app.config';
const MuscleDateRangeCalendar = _ref => {
  var _APP_CONFIGURATION$co;
  let {
    onSelect,
    value,
    minDate,
    maxDate,
    prices,
    onMonthChange,
    isMobile = false,
    behavior = (_APP_CONFIGURATION$co = APP_CONFIGURATION.config.rangeCalendarBehavior) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : 'default'
  } = _ref;
  const {
    currentLanguageCode
  } = useLanguageConfig();
  const [selected, setSelected] = React.useState(value);
  useEffect(() => {
    setSelected(value);
  }, [value]);
  const {
    modifiers,
    defaultMonth
  } = useMemo(() => {
    const currentDate = new Date();
    let defaultDisplayMonth = (selected === null || selected === void 0 ? void 0 : selected.from) || currentDate;

    // If no selection and minDate is after current date, use minDate
    if (!(selected !== null && selected !== void 0 && selected.from) && minDate && minDate > currentDate) {
      defaultDisplayMonth = minDate;
    }
    return {
      modifiers: getModifiers(prices),
      defaultMonth: defaultDisplayMonth
    };
  }, [prices, selected === null || selected === void 0 ? void 0 : selected.from, minDate]);
  const onChangeSelection = selection => {
    if (!selection) return;
    if (!(selected !== null && selected !== void 0 && selected.from) && !(selected !== null && selected !== void 0 && selected.to) || selected.from && !selected.to) {
      handleSelection(selection);
    } else {
      const {
        from: selectedFrom,
        to: selectedTo
      } = selected || {};
      const {
        from: newFrom,
        to: newTo
      } = selection;
      if (newFrom && selectedFrom && dateIsBefore(newFrom.toISOString(), selectedFrom.toISOString())) {
        handleSelection({
          from: newFrom,
          to: undefined
        });
      } else {
        handleSelection({
          from: newTo,
          to: undefined
        });
      }
    }
  };
  const onChangeSelectionCustom = selection => {
    if (selection) {
      if (selection.from && !selection.to) {
        selection.to = new Date(selection.from.getTime());
        selection.to.setDate(selection.to.getDate() + 1);
      }
      handleSelection(selection);
    } else {
      if (selected) {
        if (selected.from && selected.to && !datesAreEqual(selected.from.toISOString(), selected.to.toISOString())) {
          handleSelection({
            from: _objectSpread({}, selected).from,
            to: _objectSpread({}, selected).from
          });
        } else {
          const toDate = selected.from ? new Date(selected.from.getTime()) : undefined;
          toDate === null || toDate === void 0 || toDate.setDate(toDate.getDate() + 1);
          handleSelection({
            from: _objectSpread({}, selected).from,
            to: toDate
          });
        }
      }
    }
  };
  const handleSelection = selection => {
    setSelected(selection);
    onSelect(selection);
  };
  return __jsx("div", {
    className: "text-neutral_black w-full ".concat(isMobile ? 'rdp-mobile-full-width' : '')
  }, __jsx(DayPicker, {
    disabled: minDate ? {
      before: minDate,
      after: maxDate
    } : undefined,
    mode: "range",
    numberOfMonths: isMobile ? 1 : 2,
    selected: selected,
    onSelect: behavior === 'custom' ? onChangeSelectionCustom : onChangeSelection,
    fixedWeeks: false,
    onMonthChange: onMonthChange,
    pagedNavigation: true,
    defaultMonth: defaultMonth,
    locale: es,
    modifiers: modifiers,
    modifiersClassNames: MODIFIER_CALENDAR_CLASS_NAMES,
    components: {
      Caption: props => __jsx(CalendarCaption, _extends({}, props, {
        monthsQuantity: isMobile ? 1 : 2
      })),
      DayContent: _ref2 => {
        var _prices$find;
        let {
            date
          } = _ref2,
          props = _objectWithoutProperties(_ref2, _excluded);
        return __jsx(CalendarDayContent, _extends({
          date: date,
          price: prices === null || prices === void 0 || (_prices$find = prices.find(p => datesAreEqual(p.date, date))) === null || _prices$find === void 0 ? void 0 : _prices$find.price
        }, props));
      }
    }
  }));
};
export default MuscleDateRangeCalendar;